import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showBackTop, setShowBackTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
      setShowBackTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // メニュー開閉時にbodyスクロールを制御
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const handleFloor = () => {
    setMenuOpen(false);
    const el = document.getElementById('floor');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSystem = () => {
    setMenuOpen(false);
    const el = document.getElementById('system');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleInfo = () => {
    setMenuOpen(false);
    const el = document.getElementById('info');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleContact = () => {
    setMenuOpen(false);
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleBackTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navItems = [
    { label: 'システム', action: handleSystem },
    { label: '基本情報', action: handleInfo },
    { label: '店舗写真', action: handleFloor },
    { label: 'お問い合わせ', action: handleContact },
  ];

  return (
    <>
      <header
        id="top"
        className="fixed top-0 left-0 w-full z-50 transition-all duration-300"
        style={{
          background: scrolled ? '#AAC4DC' : 'transparent',
          borderBottom: scrolled ? '1px solid rgba(255,255,255,0.3)' : 'none',
        }}
      >
        <div className="w-full px-6 md:px-10 flex items-center justify-between" style={{ height: '70px' }}>
          {/* Logo */}
          <a href="#top" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/68f89381c4c7240bb69246b185e50103/eedb73b8ac242566b224f120759b9c49.png"
              alt="Uru"
              className="w-auto object-contain"
              style={{
                height: '52px',
                filter: 'brightness(0) invert(1)',
                transition: 'filter 0.3s',
              }}
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-7">
            {navItems.map((item) => (
              <button
                key={item.label}
                type="button"
                onClick={item.action}
                className="text-sm tracking-wider whitespace-nowrap cursor-pointer transition-colors duration-200 bg-transparent border-none outline-none"
                style={{ color: '#fff' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.color = 'rgba(255,255,255,0.65)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.color = '#fff'; }}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2 cursor-pointer"
            onClick={() => setMenuOpen(true)}
            aria-label="メニュー"
          >
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="block w-6 h-0.5 transition-all"
                style={{ background: '#fff' }}
              />
            ))}
          </button>
        </div>
      </header>

      {/* Mobile Drawer */}
      <div
        className="fixed inset-0 z-50 transition-opacity duration-300 md:hidden"
        style={{
          background: 'rgba(0,0,0,0.85)',
          opacity: menuOpen ? 1 : 0,
          pointerEvents: menuOpen ? 'auto' : 'none',
        }}
      >
        <button
          className="absolute top-5 right-5 text-white text-3xl cursor-pointer w-10 h-10 flex items-center justify-center"
          onClick={() => setMenuOpen(false)}
        >
          <i className="ri-close-line" />
        </button>
        <nav className="flex flex-col items-center justify-center h-full gap-8">
          {navItems.map((item) => (
            <button
              key={item.label}
              type="button"
              onClick={item.action}
              className="text-white text-lg tracking-widest cursor-pointer bg-transparent border-none outline-none whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Back to Top Button */}
      <button
        type="button"
        onClick={handleBackTop}
        aria-label="トップへ戻る"
        className="fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300"
        style={{
          background: '#fff',
          color: '#AAC4DC',
          border: '2px solid #AAC4DC',
          opacity: showBackTop ? 1 : 0,
          pointerEvents: showBackTop ? 'auto' : 'none',
          transform: showBackTop ? 'translateY(0)' : 'translateY(12px)',
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = '#AAC4DC';
          (e.currentTarget as HTMLButtonElement).style.color = '#fff';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = '#fff';
          (e.currentTarget as HTMLButtonElement).style.color = '#AAC4DC';
        }}
      >
        <i className="ri-arrow-up-line text-base" />
      </button>
    </>
  );
}
